import { EventMeta } from '../../../interfaces/meta.interface';

const updateCalendarDelegation: EventMeta = {
    title: 'Update Calendar Delegation',
    default: {
        description: 'Update Calendar Delegation',
        longDescription:
            "A calendar delegation was assigned to a mailbox. Calendar delegation gives someone else in the same organization permissions to manage the mailbox owner's calendar.",
        severity: 'info',
    },
};

export default updateCalendarDelegation;
